import { render, staticRenderFns } from "./Cta.vue?vue&type=template&id=64b29e1a&scoped=true"
import script from "./Cta.vue?vue&type=script&lang=js"
export * from "./Cta.vue?vue&type=script&lang=js"
import style0 from "./Cta.vue?vue&type=style&index=0&id=64b29e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b29e1a",
  null
  
)

export default component.exports